<div class="text-center text-secondary">
  <div class="icon-wrapper mb-2">
    <fa-icon [icon]="'magnifying-glass'"></fa-icon>
  </div>
  @if (searchTerm()) {
    <p>{{ noResultsMessage() | translate: { searchTerm: searchTerm() } }}</p>
  } @else {
    <p>{{ 'search.no-results' | translate }}</p>
  }
</div>
